import { getCookie } from 'cookies-next';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { appToSetString } from '@/utils/js/webView';

interface SpaceType {
  isSquareMeter: Boolean;
  setSquareMeter: (isSquareMeter: Boolean) => void;
  toggleSquareMeter: () => void;
}

export const useSpaceStore = create<SpaceType>()(
  persist(
    (set) => ({
      isSquareMeter: true, // false: 평, true: m²
      setSquareMeter: (isSquareMeter: Boolean) => set({ isSquareMeter }),
      toggleSquareMeter: () =>
        set((state) => {
          const newValue = !state.isSquareMeter;
          if (getCookie('KEY_APP_ID') === process.env.NEXT_PUBLIC_APP_ID)
            appToSetString('isPyeong', newValue ? 'N' : 'Y');
          return { isSquareMeter: newValue };
        }),
    }),
    {
      name: 'SpaceType', // name of the item in the storage (must be unique)
      // storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
